import type { OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';

export interface SessionTimeoutDialogData {
  isExpired: boolean; // Session is expired after 15 minutes inactivity
}

/**
 * Session Timeout Dialog Component
 *
 * Displays session expired message after 15 minutes of inactivity.
 * Shows only Login button - user must refresh token to continue.
 */
@Component({
  selector: 'app-session-timeout-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss']
})
export class SessionTimeoutDialogComponent implements OnDestroy {
  dialogRef = inject(MatDialogRef<SessionTimeoutDialogComponent>);
  data = inject<SessionTimeoutDialogData>(MAT_DIALOG_DATA);

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Handle Login button click
   */
  onLogin(): void {
    this.dialogRef.close('login');
  }
}
